import { useAccountInfo } from '@/hooks/query/account';
import { MarketLabel } from '@/types';
import { GameType } from '@nf/types/odds';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface OddsTableMarsContextProps {
    sport: number;
    market: MarketLabel;
	gameType: GameType;
    oddsType: number | undefined;
    actStatus: number | undefined;
	isMyFav: boolean;
	updateGameType(gameType: GameType): void;

};

const OddsTableMarsContext = createContext<OddsTableMarsContextProps>({
	sport: 0,
	market: 'l',
	gameType: undefined,
	oddsType: undefined,
	actStatus: undefined,
	isMyFav: false,
	updateGameType: () => {}
});


export const OddsTableMarsContextProvider = ({
	sport,
	gameType: defaultGameType,
	market,
	isMyFav,
	children
}: {
    sport: number;
    gameType?: GameType;
    market: MarketLabel;
	isMyFav?: boolean;
    children: React.ReactNode;
}) => {
	const [gameType, setGameType] = useState<GameType>(defaultGameType);
	const { user } = useAccountInfo();
	const updateGameType = (gameType: GameType) => {
		setGameType(gameType)
	}
	useEffect(() => {
		setGameType(defaultGameType)
	}, [defaultGameType])
	const value = useMemo(() => ({
		sport,
		market,
		gameType,
		oddsType: user?.OType,
		actStatus: user?.ActStatus,
		updateGameType,
		isMyFav: isMyFav ?? false
	}), [sport, market, gameType, user?.OType, user?.ActStatus, isMyFav]);
	return (
		<OddsTableMarsContext.Provider value={value}>
			{children}
		</OddsTableMarsContext.Provider>
	)
}

export const useOddsTableMarsContext = () => useContext(OddsTableMarsContext);